export default{
  /* 阿里 OSS 存储桶 accessKey
      * 暂时存放在 store 中
      * 后期存放在数据库
      */
  setRegion({ commit }, data) {
    commit('SET_REGION', data)
  },
  setAccessKey({ commit }, data) {
    commit('SET_ACCESSKEYID', data)
  },
  setAccessKeySecret({ commit }, data) {
    commit('SET_ACCESSKEYSECRET', data)
  },
  setBucket({ commit }, data) {
    commit('SET_BUCKET', data)
  },
  setSecure({ commit }, data) {
    commit('SET_SECURE', data)
  },
  setRefresh({commit},data){
    commit('SET_REFRESH', data)
  }
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js